import {
  OBTENER_REGISTROS,
  LIMPIAR_REGISTROS,
  OBTENER_REGISTROS_HISTORICO,
  LIMPIAR_REGISTROS_HISTORICO,
  REGISTROS_ERROR,
  ACTUALIZAR_FECHAS,
} from "types/context";

export default (state, action) => {
  switch (action.type) {
    case OBTENER_REGISTROS:
      return {
        ...state,
        registros: action.payload,
      };
    case OBTENER_REGISTROS_HISTORICO:
      return {
        ...state,
        registrosHistoricos: action.payload,
    };
    case LIMPIAR_REGISTROS_HISTORICO:
      return {
        ...state,
        registrosHistoricos: [],
      };
    case LIMPIAR_REGISTROS:
      return {
        ...state,
        registros: {},
      };
    case REGISTROS_ERROR:
      return {
        ...state,
        mensaje: action.payload,
      };
    case ACTUALIZAR_FECHAS:
      const { fechaDesde, fechaHasta } = action.payload;
      return {
        ...state,
        fechaDesde,
        fechaHasta,
      };
    default:
      return state;
  }
};
